import React from 'react';
import { Fragment } from 'react';

import { formatAndRoundMoney, formatFigure, formatQuantity } from 'Helpers/formatService';

const EMPTY = '—';

/**
 * Email-friendly, single-pass budget-line table for the EA detail view.
 *
 * Columns: Dept/Cost Centre · Budget Line · Currency · Unit price · Quantity · Total.
 * For lines with more than one quantity driver, the effective (combined) quantity
 * is the PRODUCT of the driver amounts, shown as a single number. The EA email blade
 * mirrors this exact rule.
 */
export default function PurchaseOrderApprovedLinesTable(props) {
    const rows = (props.po.detailed_amount || []).filter((row) => !(row.type && row.type === 'project'));

    const combinedQuantity = (quantities) => {
        const amounts = (quantities || []).map((quantity) => quantity?.amount).filter((amount) => amount !== null && amount !== undefined && amount !== '');

        if (amounts.length === 0) {
            return '';
        }

        const product = amounts.reduce((total, amount) => total * Number(amount), 1);

        return formatFigure(product, formatQuantity, { precision: 4 });
    };

    return (
        <table className="my-3 table table-bordered no-footer" style={{ maxWidth: '600px' }}>
            <thead className="text-dark-blue">
                <tr>
                    <th>{$t('Dept/Cost Centre')}</th>
                    <th>{$t('Budget Line')}</th>
                    <th>{$t('Currency')}</th>
                    <th>{$t('Unit price')}</th>
                    <th>{$t('Quantity')}</th>
                    <th>{$t('Total')}</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row, index) => (
                    <Fragment key={index}>
                        <tr>
                            <td>
                                {row.department || EMPTY}
                                {row.costcenter && ` / ${row.costcenter}`}
                            </td>
                            <td>{row.budget_line || EMPTY}</td>
                            <td>{row.currency ? row.currency.code : EMPTY}</td>
                            <td>{formatFigure(row.revised_price ?? row.original_price, formatAndRoundMoney)}</td>
                            <td>{combinedQuantity(row.revised_quantity?.length ? row.revised_quantity : row.original_quantity)}</td>
                            <td>{formatFigure(row.revised_total ?? row.original_total, formatAndRoundMoney)}</td>
                        </tr>
                    </Fragment>
                ))}
                {rows.length === 0 && (
                    <tr>
                        <td colSpan="6">{EMPTY}</td>
                    </tr>
                )}
                <tr className="font-weight-bold">
                    <td colSpan="5">{$t('Total')}</td>
                    <td>{formatFigure(props.po.final_price)}</td>
                </tr>
            </tbody>
        </table>
    );
}
